import { motion } from "framer-motion";

export default function LoadingScreen() {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.55, ease: "easeInOut" }}
      className="fixed inset-0 z-[100] flex items-center justify-center"
      style={{ background: "#0A1023" }}
      data-testid="loading-screen"
    >
      <div className="relative flex flex-col items-center gap-6">
        <div className="absolute -inset-24 rounded-full blur-3xl opacity-40 pointer-events-none"
          style={{ background: "radial-gradient(circle, #3B82F6 0%, transparent 60%)" }} />
        <motion.img
          src="/logo-icon-sm.png"
          alt="SKVY Harmony Placement"
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="relative w-20 h-20 object-contain drop-shadow-[0_10px_40px_rgba(59,130,246,0.55)]"
        />
        <div className="text-center">
          <p className="font-poppins font-semibold text-white text-lg tracking-tight">SKVY Harmony Placement</p>
          <p className="font-inter text-[11px] uppercase tracking-[0.28em] text-[#10B981] mt-1">Loading experience</p>
        </div>
      </div>
    </motion.div>
  );
}
